import * as React from 'react';
import { Mutation } from 'react-apollo';
import { ApolloError } from 'apollo-client';

import DEVICES_QUERY from 'settings/queries/devicesQuery.gql';
import ENABLE_DISABLE_DEVICE_MUTATION from 'settings/queries/EnableOrDisableDeviceMutation.gql';
import { EnableOrDisableDeviceVariables } from 'settings/queries/__generated__/EnableOrDisableDevice';
import ToastActions from 'actions/ToastActions';

type Props = {
  children: (
    enableOrDisableDevice: (input: { variables: EnableOrDisableDeviceVariables }) => void
  ) => React.ReactElement;
};

export default function EnableOrDisableDeviceMutationContainer(props: Props) {
  return (
    <Mutation
      mutation={ENABLE_DISABLE_DEVICE_MUTATION}
      refetchQueries={() => [{ query: DEVICES_QUERY }]}
      onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
      {props.children}
    </Mutation>
  );
}
